import React, { useRef, useState } from 'react';

// material-ui
import {
  Backdrop,
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  MenuItem,
  Paper,
  Slide,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

// project imports

import GoogleListItemDialog from '../../components/googleDrive/googleListItems';
import ListConnectorsDialog from '../../components/listConnectors';
import { useDeleteExtraction, useExtractionList } from '../../hooks/useExtraction';
import useExtractStore from '../../store/useExtract';
// import HubPage from './hub';
// import ViewDataPage from './view';
import SnackbarAlert from '../../components/alert/alertSnackbar';
import { moduleTypes } from '../../utils/utils';
import {
  useGetParticipant,
  useLoadPushData,
  useLoadPushDataCCTContractor,
  useLoadPushDataCCTLab,
  useLoadPushDataSGBuildex
} from '../../hooks/useLoads';
import { useApsUploadFile } from '../../hooks/useAps';
import SgbuildexAddOnDialog from './sgbuildexAddOnDialog';
import SgbuildexFromDetailDialog from './sgbuildexFormDetail';
import useConnectionStore from '../../store/useConnectors';
import AutodeskModuleScreen from './autodesk';
import SgbuildexParticipantDialog from './sgbuildexoSelectParticipant';

const projectInformation = {
  projectid: '6b63aff3-e50e-4c1d-8520-51f4ae31d615',
  id: '1321a518-5ad7-4191-924c-80d65987db91',
  formdate: '2026-01-10',
  customvalues: [
    {
      itemLabel: 'Project Reference Number',
      textVal: 'A1378-02312-2024'
    },
    {
      itemLabel: 'Project Title',
      textVal:
        '(BUKIT MERAH BERLAYAR C2)PROPOSED PUBLIC HOUSING DEVELOPMENT COMPRISING 1 BLOCK OF 40-STOREY, 1 BLOCK OF 8/40 STOREY, 1 BLOCK 24/32 STOREY AND 1 BLOCK OF 8/24 STOREY RESIDENTIAL BUILDINGS (TOTAL: 1039 UNITS), 1 BLOCK OF 7-STOREY MULTI-STOREY CARPARK WITH ESS, CHILD CARE CENTRE, 1 BLOCK OF SINGLE-STOREY COMMERCIAL BUILDING, 1 BLOCK OF BIN CENTRE, 2 BLOCK OF ESS AND 2 PRECINCT PAVILIONS ON LOT 02346C PT MK01 AT BERLAYAR DRIVE (BUKIT MERAH PLANNING AREA)'
    },
    {
      itemLabel: 'Project Location Description',
      textVal: 'Mukim 01 Lot02346C PT'
    },
    {
      itemLabel: 'Project Main Contractor Company Name',
      textVal: 'WEE HUR CONSTRUCTION PTE LTD'
    },
    {
      itemLabel: 'Project Main Contractor Company Unique Entity Number',
      textVal: 'T22FC0016H'
    },
    {
      itemLabel: 'Total Number of Block Zone',
      textVal: '100'
    },
    {
      itemLabel: 'Block Zone Name',
      textVal: 'Zone A'
    }
  ]
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function LoadPage() {
  const payloadLoad = useRef(null);
  const { provider, activeConnectionId, connectionOwnerName } = useConnectionStore((s) => s);
  const { hubname, openProject, setCloseProject, setHubName } = useExtractStore();
  const { mutate: deleteExtraction, isPending: isDeletingExtraction } = useDeleteExtraction();
  const { mutate: pushDataExtraction, isPending: isPushDataExtraction } = useLoadPushData();
  const { mutate: pushDataSGBuildex, isPending: isPushDataSGBuildex } = useLoadPushDataSGBuildex();
  const { mutate: pushDataCCTLab, isPending: isPushDataCCTLab } = useLoadPushDataCCTLab();
  const { mutate: pushDataCCTContractor, isPending: isPushDataCCTContractor } = useLoadPushDataCCTContractor();
  const { mutate: uploadFiletoACC, isPending: isUploadFiletoACC } = useApsUploadFile();

  const [typeModule, settypeModule] = useState('all');
  const [element, setelement] = useState('');
  const [typeParticipant, settypeParticipant] = useState("")
  const [openParticipant, setopenParticipant] = useState(false);

  const {
    data: dataExtraction,
    isFetching: isLoadingExtraction,
    isError: isErrorExtraction
  } = useExtractionList({
    type: typeModule == 'all' ? '' : typeModule
  });

  const [open, setOpen] = useState(false);

  const [openListDataDialog, setopenListDialog] = useState(false);
  const [connectors, setconnectors] = useState(null);
  const [tableName, settableName] = useState('');
  const [selectedId, setSelectedId] = useState(null);
  const [openDialogSgbuildex, setopenDialogSgbuildex] = useState(false);
  const [openAccModule, setopenAccModule] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    title: '',
    content: '',
    type: 'error'
  });

  const handleCloseSnackbar = () => {
    setSnackbar({
      open: false,
      title: '',
      content: '',
      type: 'error'
    });
  };

  const handleOpenConnectors = (row) => {
    setSelectedId(row.id);
    settableName(row.table_name);
    setOpen(true);
  };

  const handleCloseConnectors = () => {
    setOpen(false);
  };

  const handleSelectConnectors = (param) => {
    const sourceData = dataExtraction?.data.find((res) => res.id === selectedId);
    const { provider, id, metadata, label } = param;
    console.log({ param, sourceData });

    setTimeout(async () => {
      setconnectors(param);
      const payload = {
        extraction_id: selectedId.toString()
      };
      if (provider === 'redas') {
        setOpen(false);
        const redasPayload = {
          ...payload,
          destination: {
            provider: provider,
            connection_id: id,
            redas_api_identifier: metadata.apiIdentifier,
            project_id: metadata.projectId
          }
        };
        console.log(redasPayload);
        pushDataExtraction(redasPayload, {
          onSuccess: () => {
            const message = {
              open: true,
              title: `Push data to ${label} success`,
              content: `You Successfully push data to other platform`,
              type: 'success'
            };
            setSelectedId(null);
            setTimeout(() => {
              setSnackbar(message);
            }, 500);
          },
          onError: (error) => {
            setSnackbar({
              open: true,
              title: 'Push data failed',
              content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
              type: 'error'
            });
          }
        });
      }

      if (sourceData.type === 'spreadsheets' && provider === 'autodesk') {
        setopenAccModule(true);
        payloadLoad.current = payload;
      }

      if (sourceData.type === 'Concrete Cube Test' && provider === 'autodesk') {
        console.log('push cct to acc');
        payloadLoad.current = payload;
        setopenAccModule(true);
      }

      if (sourceData.type === 'Concrete Cube Test' && provider === 'sgbuildex') {
        console.log('push cct to dex');
        console.log(payload);
        payloadLoad.current = payload;
        // const ele = sourceData.type === 'Concrete Cube Test' ? 'concrete_cube_test_contractor' : 'site_progress';
        const ele = 'concrete_cube_test_contractor';
        settypeParticipant("cct")
        setelement(ele);
        setOpen(false);
        setopenParticipant(true);
      }

      if (sourceData.type === 'forms' && provider === 'sgbuildex') {
        const ele ='site_progress';
        settypeParticipant("site_progress")
        setelement(ele);
        setOpen(false);
        handleBackHub();
        setTimeout(() => {
          setopenDialogSgbuildex(true);
        }, 100);
      }
    }, 200);
  };

  const handlePushCCTContractorSgbuildex = (data) => {
    const payload = {
      ...data,
      ...payloadLoad.current
    };
    console.log({ payload });
    pushDataCCTContractor(payload, {
      onSuccess: () => {
        const message = {
          open: true,
          title: `Push data to SGBuildex success`,
          content: `You Successfully push data to platform SGBuildex`,
          type: 'success'
        };
        setopenParticipant(false);
        setSelectedId(null);
        setTimeout(() => {
          setSnackbar(message);
        }, 500);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Push data failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  }

  const handleLoadSgbuildex = (data) => {
    const payload = {
      destination: { connection_id: activeConnectionId.toString() },
      data: [...data]
    };
    console.log('send to sgbuildex', payload);
    payloadLoad.current = payload;
    setOpen(false)
    setopenDialogSgbuildex(false);
    setopenParticipant(true);
  };



  const handlePushSiteProgressSgbuildex = (data) => {
    const val = payloadLoad.current
    const payload = {
     ...val,
     ...data
    }
    console.log(payload)
    pushDataSGBuildex(payload, {
      onSuccess: () => {
        const message = {
          open: true,
          title: `Push data to SGBuildex success`,
          content: `You Successfully push data to platform SGBuildex`,
          type: 'success'
        };
        setopenParticipant(false);
        setSelectedId(null);
        setTimeout(() => {
          setSnackbar(message);
        }, 500);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Push data failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });

  }

  const handleCloseParticipant = () => {
    if(element === "concrete_cube_test_contractor"){
     setOpen(true)
    }

    if(element === "site_progress"){
      setopenDialogSgbuildex(true);
    }
    setopenParticipant(false);
  };

  const handleConfirmParticipant = (data) => {
    if(element === "concrete_cube_test_contractor"){
      handlePushCCTContractorSgbuildex(data)
    }

    if(element === "site_progress"){
      handlePushSiteProgressSgbuildex(data)
    }
    
  };

  const handleCloseSgBuildex = () => {
    setopenDialogSgbuildex(false);
    setOpen(true);
  };

  const handleCloseListDataDialog = () => {
    setopenListDialog(false);
  };

  const handleBackHub = () => {
    setHubName('');
    setCloseProject(false);
  };

  const handleConfirmAutodesk = (param) => {
    setopenAccModule(false);
    setOpen(false);
    const sourceData = dataExtraction?.data.find((res) => res.id === selectedId);
    if (sourceData.type === 'spreadsheets') {
      console.log('wenti lab', param);
      const data = payloadLoad.current;
      const payload = {
        ...data,
        destination: param
      };
      console.log(payload);
      pushDataExtraction(payload, {
        onSuccess: () => {
          const message = {
            open: true,
            title: `Push data to Autodesk success`,
            content: `You Successfully push data to other Autodesk platform`,
            type: 'success'
          };

          setSelectedId(null);
          setTimeout(() => {
            setSnackbar(message);
          }, 500);
        },
        onError: (error) => {
          setSnackbar({
            open: true,
            title: 'Push data failed',
            content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
            type: 'error'
          });
        }
      });
    }

    if (sourceData.type === 'Concrete Cube Test') {
      console.log('CCT Lab', param);
      const data = payloadLoad.current;
      const payload = {
        ...data,
        destination: param
      };
      console.log(payload);
      pushDataCCTLab(payload, {
        onSuccess: () => {
          const message = {
            open: true,
            title: `Push data to Autodesk success`,
            content: `You Successfully push data CCT Lab to Autodesk`,
            type: 'success'
          };

          setSelectedId(null);
          setTimeout(() => {
            setSnackbar(message);
          }, 500);
        },
        onError: (error) => {
          setSnackbar({
            open: true,
            title: 'Push data failed',
            content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
            type: 'error'
          });
        }
      });
    }
  };

  const isExtracting = isPushDataExtraction || isPushDataSGBuildex || isPushDataCCTContractor || isPushDataCCTLab;

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.modal * 3 })}
        
        open={isExtracting}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {snackbar.open && <SnackbarAlert open={snackbar.open} handleClose={handleCloseSnackbar} message={snackbar} />}
      <Box>
        <Stack direction={'row'} justifyContent={'space-between'} spacing={2} flex={1}>
          <TextField
            sx={{
              width: '20%'
            }}
            id="outlined-select-currency"
            select
            label="Select Type"
            defaultValue="all"
            value={typeModule}
            onChange={(e) => settypeModule(e.target.value)}
            // helperText="Please select your currency"
          >
            {moduleTypes.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        <Paper
          elevation={1}
          sx={{
            mt: 3,
            background: '#fff'
            // p: 1
          }}
        >
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#ffffff' }}>
                  <TableCell>
                    <strong>Type</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Data Source</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {dataExtraction &&
                  dataExtraction?.data.map((row) => {
                    const isNotAcc = row.type !== 'excel' && row.type !== 'spreadsheets';
                    return (
                      <TableRow key={row.id}>
                        <TableCell>
                          <Typography fontWeight="bold">{moduleTypes.find((res) => res.value === row.type)?.label}</Typography>
                        </TableCell>
                        <TableCell>
                          {isNotAcc && (
                            // <Typography variant="body2" color="text.secondary">
                            //    {`${row?.metadata?.connection_user_name} |`}  {`${row?.metadata?.hub_name} |`} {row?.metadata?.project_name || row?.metadata?.name}
                            // </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {[
                                row?.metadata?.connection_user_name,
                                row?.metadata?.hub_name,
                                row?.metadata?.project_name || row?.metadata?.name
                              ]
                                .filter(Boolean)
                                .join(' | ')}
                            </Typography>
                          )}

                          {row.type == 'excel' && (
                            <Typography variant="body2" color="text.secondary">
                              {row.metadata.name}
                            </Typography>
                          )}

                          {row.type == 'spreadsheets' && (
                            <Typography variant="body2" color="text.secondary">
                              {row.metadata.name}
                            </Typography>
                          )}
                        </TableCell>

                        <TableCell align="center">
                          <Tooltip title="Load Data">
                            <IconButton
                              onClick={() => handleOpenConnectors(row)}
                              sx={{
                                width: 36,
                                height: 36,
                                border: '1px solid',
                                borderColor: 'primary.light',
                                color: 'primary.main',
                                '&:hover': {
                                  bgcolor: 'primary.main',
                                  color: '#fff'
                                }
                              }}
                            >
                              <CloudUploadIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {open && (
          <ListConnectorsDialog
            module="loads"
            open={open}
            onCancel={handleCloseConnectors}
            onConfirm={(param) => handleSelectConnectors(param)}
          />
        )}

        <AutodeskModuleScreen open={openAccModule} onClose={() => setopenAccModule(false)} onConfirm={handleConfirmAutodesk} />

        <SgbuildexFromDetailDialog
          table={tableName}
          open={openDialogSgbuildex}
          onClose={handleCloseSgBuildex}
          onConfirm={handleLoadSgbuildex}
        />

        <SgbuildexParticipantDialog
          // type={typeParticipant}
          element={element}
          open={openParticipant}
          onClose={handleCloseParticipant}
          onConfirm={handleConfirmParticipant}
        />

        {openListDataDialog && (
          <GoogleListItemDialog
            dataConnection={connectors}
            open={openListDataDialog}
            onCancel={handleCloseListDataDialog}
            onConfirm={(param) => handleCloseListDataDialog(param)}
          />
        )}
      </Box>
    </>
  );
}
